import { Flex, Link, Text } from '@chakra-ui/react'
import { ExclamationTriangleIcon } from 'components'
import { sendIntercomMessage, useLimitedResourceCounts } from 'utils'

export default function MultipleLimitsWarning() {
  const { limitCounts = 0 } = useLimitedResourceCounts()
  if (limitCounts < 2) return

  return (
    <Flex
      alignItems="center"
      backgroundColor="danger.100"
      gap={3}
      color="danger.600"
      borderRadius="sm"
      p={4}
      border="1px"
      borderColor="danger.600"
    >
      <ExclamationTriangleIcon size="lg" />
      <Text lineHeight={1.1}>
        You have reached the limit for multiple services below in your current plan. Please upgrade
        your plan to exceed these limits or{' '}
        <Link
          textDecoration="underline"
          onClick={() =>
            sendIntercomMessage('Hello, I am interested in upgrading my current subscription.')
          }
        >
          contact our support team
        </Link>{' '}
        for more information.
      </Text>
    </Flex>
  )
}
